import React from 'react'
import styles from './index.module.scss'

export default function BoardColumnTitle({ title, color, count }: any){
    return (
        <div className={styles.boardColumnTitle}>
            <div className={styles.boardColumnTitle__content} style={{background: color}}>
                <div className={styles.boardColumnTitle__name}>
                    {title}
                </div>
                <div className={styles.boardColumnTitle__count}>
                    {count}
                </div>
            </div>
        </div>
    )
}
